<div class="delete-confirmation-container">
    <h2 class="dialog-title">
        Delete {{ displayTitleDescription }}?
    </h2>

    <div class="dialog-content">
        <p *ngIf="data?.fullDescription; else simpleBlock">
            {{ data.fullDescription }}
        </p>
        <ng-template #simpleBlock>
            <p>You are about to remove {{ displayMessage }}{{ displayDescription }}. Are you sure?</p>
        </ng-template>
    </div>

    <div class="dialog-actions">
        <button 
            mat-flat-button 
            (click)="onConfirmClick()"
            color="warn">
            Confirm
        </button>
        <button 
            mat-stroked-button
            (click)="onCancelClick()">
            Cancel
        </button>
    </div>
</div>
